var _excluded = ["user_number", "user_id", "event_id", "page_type", "page_str", "pre_page_str"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @file 发送 Page View
 * @author dafo<huanghouin@baijiahulian.com>
 * @module module/view
 */
import request from './util/request';
import configurable from './util/configurable';
import { camelToUnder } from './util/json';
import { on, off, getPageURL } from './util/dom';
import { trackID, userID, Config } from './util/config';
/**
 * 上一个页面的 URL，对于 SPA 来说是上一个路由的地址
 */

var previousPageURL;
/**
 * 在 sessionStorage 中保存上一页地址的键名
 *
 * @const {string}
 */

var STORAGE_KEY = 'pre_page_str';
/**
 * 保存上一页地址到 sessiongStorage
 *
 * @function
 * @param {string=} [url=previousPageURL] 要保存作为上一个页面地址的 URL
 */

var save = function save() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : previousPageURL;

  if (!url) {
    url = getPageURL();
  }

  sessionStorage.setItem(STORAGE_KEY, url);
};
/**
 * 页面浏览上报
 *
 * @function
 * @param {Object} json 要上报的数据
 * @param {Function=} callback 上报后的回调
 */


var report = configurable(function (json, callback) {
  var _camelToUnder = camelToUnder(json),
      _camelToUnder$user_nu = _camelToUnder.user_number,
      user_number = _camelToUnder$user_nu === void 0 ? userID : _camelToUnder$user_nu,
      _camelToUnder$user_id = _camelToUnder.user_id,
      user_id = _camelToUnder$user_id === void 0 ? user_number : _camelToUnder$user_id,
      _camelToUnder$event_i = _camelToUnder.event_id,
      event_id = _camelToUnder$event_i === void 0 ? '' : _camelToUnder$event_i,
      page_type = _camelToUnder.page_type,
      page_str = _camelToUnder.page_str,
      _camelToUnder$pre_pag = _camelToUnder.pre_page_str,
      pre_page_str = _camelToUnder$pre_pag === void 0 ? sessionStorage.getItem(STORAGE_KEY) : _camelToUnder$pre_pag,
      rest = _objectWithoutProperties(_camelToUnder, _excluded); // 必要的上报数据


  var pageViewData = _objectSpread({
    // 当前页面 URL
    page_url: location.href,
    // 事件 id
    event_id: event_id,
    // 前一个页面的 URL
    referrer: document.referrer,
    // 同 user_id，兼容之用
    user_number: user_number,
    // 登录用户的 number
    user_id: user_id,
    // 页面类型，可以直接写死为业务，例如高途为 gaotu
    page_type: page_type,
    // 页面具体类别划分，例如：/gaotu/detail/course@a=1@b=2
    page_str: page_str,
    // 前一个页面的 page_str
    pre_page_str: pre_page_str,
    // 用户的唯一标识，由后端生成写到 cookie 中
    track_id: trackID
  }, rest);

  if (page_str) {
    previousPageURL = page_str;
    save(page_str);
  }

  request(Config.VERB)("".concat(Config.PV), pageViewData, callback);
});
var win = typeof window !== 'undefined' && window;
/**
 * 在 unload 时保存当前页面作为上一个页面的地址
 *
 * @function
 */

var savePreviousPageURL = function savePreviousPageURL() {
  off(win, 'unload', savePreviousPageURL);
  save();
};

on(win, 'unload', savePreviousPageURL);
export default report;